import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoujjainurbaniabushire() {



    const cardData =
    {
        keyword: 'Pune to Ujjain Urbania Bus Hire',
        heading: 'Urbania on rent in pune: Pune to Ujjain Urbania Bus Hire',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Pune to Ujjain Urbania Bus Hire for pilgrims, corporate groups, families, and tourists planning comfortable group travel from Pune to Ujjain. Our well‑maintained Force Urbania bus fleet provides spacious seating, air‑conditioned comfort, and smooth performance, making it ideal for long-distance journeys, airport transfers, weddings, sightseeing tours, and spiritual trips. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for Pune to Ujjain Urbania bus hire.',

        top: 'Top Places to Visit in Ujjain with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Mahakaleshwar Jyotirlinga",
    "description": "Mahakaleshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and the spiritual heart of Ujjain. Known for its magnificent architecture, the temple attracts thousands of devotees daily. The Bhasma Aarti, held early morning, is a unique ritual where priests perform worship with sacred ash. The temple is an important pilgrimage site and a symbol of devotion, spirituality, and ancient Indian culture."
  },
  {
    "title": "Kal Bhairav Temple",
    "description": "Kal Bhairav Temple is dedicated to Lord Bhairav, an incarnation of Shiva. Famous for its deity that requires devotees to offer liquor as part of rituals, it attracts large crowds seeking blessings and protection. The temple’s unique customs, spiritual aura, and rich history make it a significant landmark in Ujjain."
  },
  {
    "title": "Harsiddhi Temple",
    "description": "Harsiddhi Temple is dedicated to Goddess Harsiddhi, a form of Shakti, and is one of the most ancient temples in Ujjain. The temple features intricate carvings, tall spires, and an impressive entrance gate. Festivals and fairs held here attract devotees from across the region, making it a hub of religious and cultural activity."
  },
  {
    "title": "Ram Ghat",
    "description": "Ram Ghat is a serene riverfront on the banks of the Shipra River, known for its early morning and evening aarti rituals. Devotees gather to offer prayers and participate in traditional ceremonies. The ghat is also a cultural hotspot during festivals like Kumbh Mela, providing a beautiful riverside experience rich in spirituality and local tradition."
  },
  {
    "title": "Bade Ganesh Temple",
    "description": "Bade Ganesh Temple houses a huge idol of Lord Ganesha and is one of the most visited sites in Ujjain. Devotees come here for blessings, especially during Ganesh Chaturthi. The temple’s architecture, religious significance, and vibrant atmosphere make it a popular destination for pilgrims and tourists alike."
  },
  {
    "title": "Chintaman Ganesh Temple",
    "description": "Chintaman Ganesh Temple is dedicated to Lord Ganesha and is famous for fulfilling devotees’ wishes. Known for its spiritual environment and historical significance, the temple attracts thousands of pilgrims seeking solace, guidance, and divine blessings. The surrounding area also has a rich cultural and historical heritage."
  },
  {
    "title": "Kaliadeh Palace",
    "description": "Kaliadeh Palace is a historic riverside palace located on the banks of the Shipra River. Built with intricate architecture and beautiful gardens, it was historically used by local rulers. Today, it attracts tourists for its architectural beauty, scenic surroundings, and historical charm."
  },
  {
    "title": "Sandipani Ashram",
    "description": "Sandipani Ashram is believed to be the place where Lord Krishna and Sudama received their education. The ashram has spiritual significance and ancient heritage, attracting devotees, history enthusiasts, and scholars interested in Indian mythology and education traditions."
  },
  {
    "title": "Kumbh Mela Grounds",
    "description": "Ujjain is one of the four locations of the Kumbh Mela, a major Hindu pilgrimage and festival held every 12 years. The grounds on the banks of the Shipra River host millions of pilgrims who come for holy baths and rituals. The festival is an unparalleled spiritual, cultural, and social experience."
  },
  {
    "title": "Gopal Mandir",
    "description": "Gopal Mandir is a historic temple dedicated to Lord Krishna, featuring beautifully carved wooden doors and pillars. Devotees visit for daily worship, religious festivals, and to admire the temple’s architectural elegance. It is a significant cultural and spiritual landmark in Ujjain."
  }
],




 "services": [
    {
      "name": "Pune to Ujjain Urbania Bus Hire",
      "description": "Pune to Ujjain Urbania Bus Hire provides reliable and comfortable buses for travel between Pune and Ujjain. Ideal for families, groups, and corporate travelers seeking hassle-free transportation."
    },
    {
      "name": "Ujjain Urbania on Rent from Pune",
      "description": "Ujjain Urbania on Rent from Pune offers convenient rental options for AC and non-AC Urbania buses, ensuring safe and timely travel for pilgrims and tourists traveling to Ujjain."
    },
    {
      "name": "Urbania Bus Rental Pune to Ujjain",
      "description": "Urbania Bus Rental Pune to Ujjain provides well-maintained buses for long-distance journeys, featuring comfortable seating, luggage support, and professional drivers familiar with the Pune-Ujjain route."
    },
    {
      "name": "Urbania AC Bus Pune to Ujjain",
      "description": "Urbania AC Bus Pune to Ujjain ensures a comfortable, climate-controlled journey with fully air-conditioned buses and experienced chauffeurs for a smooth trip between Pune and Ujjain."
    },
    {
      "name": "Pune Ujjain Urbania One Way Hire",
      "description": "Pune Ujjain Urbania One Way Hire offers flexible one-way bus rental services for travelers going from Pune to Ujjain, ensuring punctuality, safety, and comfort."
    },
    {
      "name": "Pune Ujjain Urbania Round Trip Hire",
      "description": "Pune Ujjain Urbania Round Trip Hire provides hassle-free round-trip bus services with professional drivers and reliable schedules, perfect for group and family travel."
    },
    {
      "name": "Corporate Urbania Pune to Ujjain",
      "description": "Corporate Urbania Pune to Ujjain offers organized bus transport for corporate groups, with AC buses, trained chauffeurs, and timely pickups for a smooth business or team travel experience."
    },
    {
      "name": "Family Tour Urbania Pune to Ujjain",
      "description": "Family Tour Urbania Pune to Ujjain provides buses designed for family trips, ensuring spacious seating, safety, and a comfortable travel experience for all members."
    },
    {
      "name": "Luxury Urbania Pune to Ujjain",
      "description": "Luxury Urbania Pune to Ujjain delivers premium AC buses with plush seating, modern interiors, and professional drivers for VIP and luxury travel between Pune and Ujjain."
    },
    {
      "name": "Affordable Urbania Pune to Ujjain",
      "description": "Affordable Urbania Pune to Ujjain offers budget-friendly bus rentals without compromising safety or comfort, ideal for families and groups seeking economical travel options."
    },
    {
      "name": "Chauffeur Driven Urbania Pune to Ujjain",
      "description": "Chauffeur Driven Urbania Pune to Ujjain ensures a stress-free journey with verified, experienced drivers, perfect for families, corporate groups, and tourists."
    },
    {
      "name": "Pune Ujjain Urbania Travel Service",
      "description": "Pune Ujjain Urbania Travel Service provides reliable and secure bus rental options for trips between Pune and Ujjain, featuring AC/non-AC buses and excellent customer support."
    },
    {
      "name": "Best Urbania Hire Pune to Ujjain",
      "description": "Best Urbania Hire Pune to Ujjain offers top-rated buses and services for Pune-Ujjain travel, including punctual pickups, comfortable seating, and professional drivers."
    },
    {
      "name": "Pune to Ujjain Urbania Booking",
      "description": "Pune to Ujjain Urbania Booking allows easy reservation of Urbania buses for travel to Ujjain, ensuring timely pickups and a smooth journey for all travelers."
    },
    {
      "name": "Urbania Pilgrimage Trip Pune to Ujjain",
      "description": "Urbania Pilgrimage Trip Pune to Ujjain specializes in organized religious tours, providing AC buses, experienced chauffeurs, and a spiritually fulfilling travel experience."
    }
  ],
  "tableData": [
    ["Pune to Ujjain Urbania Bus Hire", "Ujjain Urbania on Rent from Pune"],
    ["Urbania Bus Rental Pune to Ujjain", "Urbania AC Bus Pune to Ujjain"],
    ["Pune Ujjain Urbania One Way Hire", "Pune Ujjain Urbania Round Trip Hire"],
    ["Corporate Urbania Pune to Ujjain", "Family Tour Urbania Pune to Ujjain"],
    ["Luxury Urbania Pune to Ujjain", "Affordable Urbania Pune to Ujjain"],
    ["Chauffeur Driven Urbania Pune to Ujjain", "Pune Ujjain Urbania Travel Service"],
    ["Best Urbania Hire Pune to Ujjain", "Pune to Ujjain Urbania Booking"],
    ["Urbania Pilgrimage Trip Pune to Ujjain", ""]
  ],



 whychoose : [
    {
        "WhyChooseheading": "Pune to Ujjain Urbania Bus Hire for Comfortable Travel",
        "WhyChoosedescription": "Pune to Ujjain Urbania Bus Hire is ideal for long-distance pilgrimages, group travel, family trips, corporate tours, and leisure journeys, ensuring a comfortable and hassle-free ride."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses for Pune to Ujjain travel are fully equipped with air-conditioning, ample legroom, reclining seats, and sufficient luggage space for a smooth long-distance journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Long-Distance Routes",
        "WhyChoosedescription": "All drivers are trained and experienced in handling long-distance travel from Pune to Ujjain, ensuring safe, punctual, and stress-free journeys."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Pune to Ujjain Urbania Bus Hire offers competitive rates with no hidden charges, making long-distance travel cost-effective and enjoyable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for single-day trips, multi-day journeys, family tours, group travels, and corporate outings with customized routes and schedules."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and maintained to ensure passenger comfort and safety during the journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Pune to Ujjain Urbania Bus Hire service guarantees on-time departures and dependable service for a smooth travel experience."
    }
]
    }
const faqData = [
    {
        question: 'Can Pune to Ujjain Urbania Bus Hire be booked for long-distance travel?',
        answer: 'Yes, it can be booked for long-distance pilgrimages, family trips, corporate tours, and group journeys from Pune to Ujjain.'
    },
    {
        question: 'How can I book Pune to Ujjain Urbania Bus Hire?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for convenient and quick reservations.'
    },
    {
        question: 'Why choose Pune to Ujjain Urbania Bus Hire?',
        answer: 'This service offers comfortable seating, professional drivers, clean vehicles, transparent pricing, and flexible travel plans for long-distance trips.'
    },
    {
        question: 'Are the drivers experienced for Pune to Ujjain routes?',
        answer: 'Yes, all drivers are licensed, trained, and familiar with the Pune to Ujjain route, ensuring safe and timely travel.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Pune and nearby areas.'
    },
    {
        question: 'Is Pune to Ujjain Urbania Bus Hire available 24/7?',
        answer: 'Yes, both bookings and customer support are available 24/7 for your convenience.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained to ensure passenger safety and comfort.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey for a hassle-free travel experience.'
    },
    {
        question: 'Is this service suitable for families, corporate groups, and pilgrims?',
        answer: 'Yes, Pune to Ujjain Urbania Bus Hire is perfect for family trips, corporate tours, group pilgrimages, and long-distance travel.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ramesh Joshi',
        feedback: 'The Pune to Ujjain Urbania Bus Hire made our pilgrimage journey comfortable and smooth. Very spacious and reliable service.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Anjali Deshmukh',
        feedback: 'We booked the Urbania bus for a multi-day trip to Ujjain. The journey was hassle-free, vehicles were clean, and drivers were professional.',
        rating: 5
    },
    {
        id: 3,
        name: 'Mr. Saurabh Patil',
        feedback: 'Our long-distance trip from Pune to Ujjain was memorable thanks to the punctual and comfortable Urbania bus service. Highly recommended.',
        rating: 5
    }
];





































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ujjain Urbania Bus Hire",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-ujjain-urbania.jpg",
  "description": "Pune to Ujjain Urbania Bus Hire offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation from Pune to Ujjain.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-ujjain-urbania-bus-hire"
  }
};







    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Ujjain Urbania Bus Hire | AC Urbania Bus One Way & Round Trip 
  </title>

  <meta
    name="description"
    content="Book Pune to Ujjain Urbania Bus Hire for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation from Pune to Ujjain."
  />

  <meta
    name="keywords"
    content="Pune to Ujjain Urbania Bus Hire, Ujjain Urbania on Rent from Pune, Urbania Bus Rental Pune to Ujjain, Urbania AC Bus Pune to Ujjain, Pune Ujjain Urbania One Way Hire, Pune Ujjain Urbania Round Trip Hire, Corporate Urbania Pune to Ujjain, Family Tour Urbania Pune to Ujjain, Luxury Urbania Pune to Ujjain, Affordable Urbania Pune to Ujjain, Chauffeur Driven Urbania Pune to Ujjain, Pune Ujjain Urbania Travel Service, Best Urbania Hire Pune to Ujjain, Pune to Ujjain Urbania Booking, Urbania Pilgrimage Trip Pune to Ujjain"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/82.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoujjainurbaniabushire;